module.exports = __webpack_public_path__ + "static/media/mongodb.7e99a108.svg";